// extracted by mini-css-extract-plugin
module.exports = {"container":"IdleScreen__container__2x2qb layout__absolute-full__3uiy6 layout__fill-center__3V8Ju","row":"IdleScreen__row__qwlEI"};